import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_HOST;

export type BrandingResponse = {
  status: string;
  data: {
    company: {
      id: string;
      name: string;
      logo?: string;
    };
    branding: {
      primaryColor: string;
      secondaryColor: string;
      accentColor: string;
    };
  };
};

export const brandingService = {
  async getBranding(): Promise<BrandingResponse> {
    const response = await axios.get(`${API_BASE_URL}/v1/dashboard/branding`);
    return response.data;
  },
};
